import { Dropdown, Alert, Modal } from 'bootstrap'
import Menu from './core/menu'
import Helpers from './core/helpers'
import Swal from 'sweetalert2'
import flatpickr from 'flatpickr'
import predefinedRangesPlugin from '../vendor/flatpickr-predifined-ranges-plugin';
import moment from 'moment';

function srnPc() {
    let d = new Date();
    let dateint = d.getTime();
    let letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let total = letters.length;
    let keyTemp = "";
    for (let i = 0; i < 6; i++) {
        keyTemp += letters[parseInt((Math.random() * (total - 1) + 1))];
    }
    keyTemp += dateint;
    return keyTemp;
}

function generateToken() {
    if (!localStorage.getItem('srnPc')) {
        localStorage.setItem('srnPc', srnPc());
        Swal.fire({
            icon: 'success',
            title: 'Token generado..!',
            text: 'Token: ' + localStorage.getItem('srnPc')
        });
    } else {
        Swal.fire({
            icon: 'warning',
            title: 'El token generado es:',
            text: localStorage.getItem('srnPc')
        });
    }
}

window.BASE_URL = '/'
window.ASSET_URL = '/'
if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    window.BASE_URL = '/security/'
    window.ASSET_URL = '/security/public/'
} else {
    window.BASE_URL = location.origin + '/'
    window.ASSET_URL = location.origin + '/'
}

(function () {
    flatpickr('#keysReportDateInput', {
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d',
        mode: 'range',
        locale: {
            firstDayOfWeek: 1 // start week on Monday
        },
        plugins: [
            new predefinedRangesPlugin([
                {label: 'Today', start: moment().format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
                {
                    label: 'Yesterday',
                    start: moment().subtract(1, 'days').format('YYYY-MM-DD'),
                    end: moment().subtract(1, 'days').format('YYYY-MM-DD')
                },
                {
                    label: 'Last 7 Days',
                    start: moment().subtract(6, 'days').format('YYYY-MM-DD'),
                    end: moment().format('YYYY-MM-DD')
                },
                {
                    label: 'Last 30 Days',
                    start: moment().subtract(29, 'days').format('YYYY-MM-DD'),
                    end: moment().format('YYYY-MM-DD')
                },
                {
                    label: 'This Month',
                    start: moment().startOf('month').format('YYYY-MM-DD'),
                    end: moment().endOf('month').format('YYYY-MM-DD')
                },
                {
                    label: 'Last Month',
                    start: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
                    end: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
                },
            ])
        ],
    })

    let menu, animate


    // Initialize menu
    //-----------------
    let layoutMenuEl = document.querySelectorAll('#layout-menu');
    layoutMenuEl.forEach(function (element) {
        menu = new Menu(element, {
            orientation: 'vertical',
            closeChildren: false
        });
        // Change parameter to true if you want scroll animation
        Helpers.scrollToActive((animate = false));
        Helpers.mainMenu = menu;
    });

    // Initialize menu togglers and bind click on each
    let menuToggler = document.querySelectorAll('.layout-menu-toggle');
    menuToggler.forEach(item => {
        item.addEventListener('click', event => {
            event.preventDefault();
            Helpers.toggleCollapsed();
        });
    });

    // Display menu toggle (layout-menu-toggle) on hover with delay
    let delay = function (elem, callback) {
        let timeout = null;
        elem.onmouseenter = function () {
            // Set timeout to be a timer which will invoke callback after 300ms (not for small screen)
            if (!Helpers.isSmallScreen()) {
                timeout = setTimeout(callback, 300);
            } else {
                timeout = setTimeout(callback, 0);
            }
        };

        elem.onmouseleave = function () {
            // Clear any timers set to timeout
            document.querySelector('.layout-menu-toggle').classList.remove('d-block');
            clearTimeout(timeout);
        };
    };
    if (document.getElementById('layout-menu')) {
        delay(document.getElementById('layout-menu'), function () {
            // not for small screen
            if (!Helpers.isSmallScreen()) {
                document.querySelector('.layout-menu-toggle').classList.add('d-block');
            }
        });
    }

    // Display in main menu when menu scrolls
    let menuInnerContainer = document.getElementsByClassName('menu-inner'),
        menuInnerShadow = document.getElementsByClassName('menu-inner-shadow')[0];
    if (menuInnerContainer.length > 0 && menuInnerShadow) {
        menuInnerContainer[0].addEventListener('ps-scroll-y', function () {
            if (this.querySelector('.ps__thumb-y').offsetTop) {
                menuInnerShadow.style.display = 'block';
            } else {
                menuInnerShadow.style.display = 'none';
            }
        });
    }

    // Init helpers & misc
    // --------------------

    // Init BS Tooltip
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    // Accordion active class
    const accordionActiveFunction = function (e) {
        if (e.type == 'show.bs.collapse' || e.type == 'show.bs.collapse') {
            e.target.closest('.accordion-item').classList.add('active');
        } else {
            e.target.closest('.accordion-item').classList.remove('active');
        }
    };

    const accordionTriggerList = [].slice.call(document.querySelectorAll('.accordion'));
    const accordionList = accordionTriggerList.map(function (accordionTriggerEl) {
        accordionTriggerEl.addEventListener('show.bs.collapse', accordionActiveFunction);
        accordionTriggerEl.addEventListener('hide.bs.collapse', accordionActiveFunction);
    });

    // Auto update layout based on screen size
    Helpers.setAutoUpdate(true);

    // Toggle Password Visibility
    Helpers.initPasswordToggle();

    // Speech To Text
    Helpers.initSpeechToText();

    // Manage menu expanded/collapsed with templateCustomizer & local storage
    //------------------------------------------------------------------

    // If current layout is horizontal OR current window screen is small (overlay menu) than return from here
    if (Helpers.isSmallScreen()) {
        return;
    }

    // If current layout is vertical and current window screen is > small

    // Auto update menu collapsed/expanded based on the themeConfig
    Helpers.setCollapsed(true, false);
})();
